module.exports = __webpack_public_path__ + "static/trendGiletFrontLogo-95662d145cc3a8d738fe07a8d3eeb5bf.jpg";